var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"color":_vm.getAlert.type,"value":_vm.getActive,"multi-line":true,"timeout":"-1"},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attrs = ref.attrs;
return [_c('v-btn',_vm._b({attrs:{"text":""},on:{"click":_vm.removeAlert}},'v-btn',attrs,false),[_vm._v("Close")])]}}])},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.getAlert.message)}})])}
var staticRenderFns = []

export { render, staticRenderFns }